// An upload the server refused because the file did not reach storage whole, or because it is a video still being
// exported (backend app/upload_whole.py; KNOWN-ISSUES 0bx). 2026-10-26: an editor chose a review video while its export
// had only just begun (24 bytes, a header and no pictures); it was kept as "completed" and the editor saw nothing
// wrong. Now the server refuses it, and these are its own words, which say what to do: wait for the export and choose
// the file again, or retry. Anything else is not one of these refusals: null.
export const UPLOAD_REFUSALS = ['upload_not_whole', 'upload_not_in_storage', 'video_still_exporting'];

export function uploadRefusalOf(error) {
  const data = error?.response?.data;
  if (!data || typeof data !== 'object') return null;
  // confirm-upload and complete-multipart answer {error, detail: words}
  if (UPLOAD_REFUSALS.includes(data.error) && typeof data.detail === 'string' && data.detail) return data.detail;
  // presign-upload answers {detail: {code, message}}
  const d = data.detail;
  if (d && typeof d === 'object' && UPLOAD_REFUSALS.includes(d.code) && typeof d.message === 'string' && d.message) {
    return d.message;
  }
  return null;
}

// Completing a multipart upload is retried on a hiccup; a refusal is final (the file in storage is not whole, and the
// upload is marked failed), so asking again cannot change it: the loop stops at once and the words are shown.
export function completionRefused(error) {
  return error?.response?.status === 422 && uploadRefusalOf(error) !== null;
}
